import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Log from './UI.Log';
import {
    Icon,
    Button,
    Form,
    Row,
    Col,
    Input,
    Select
} from 'antd';

const css = require('./index.scss');
const FormItem = Form.Item;
const Option = Select.Option;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const getFieldDecorator = this.props.form.getFieldDecorator;
        const companyInfo = this.modulesState.companyInfo;
        const editDetail = this.modulesState.editDetail;
        const countryOpts = this.modulesState.countryInfo ? this.modulesState.countryInfo : [];
        const stateOptions = this.modulesState.countryStates ? this.modulesState.countryStates : [];
        const cityOptions = this.modulesState.countryStateCities ? this.modulesState.countryStateCities : [];
        return (
            <div className={`${css['company-contariner']}`}>
                <header>
                    <h2>基本信息</h2>
                    {
                        editDetail ? (
                            <div className={css['company-contariner-hander']}>
                                <Button
                                    onClick={this.cancelProtect}
                                >取消
                                </Button>
                                <Button 
                                    type="primary"
                                    onClick={
                                        () => {
                                            this.updateDetail();
                                        }
                                    }
                                >保存
                                </Button>
                            </div>
                        ) : (
                            <Icon 
                                type="edit"
                                onClick={
                                    () => {
                                        this.updateDetailStatu(true);
                                    }
                                }
                            />
                        )
                    }
                </header>
                <div className={css['companyDetail']}>
                    <Log/>
                    <Form 
                        layout="vertical"
                        className={css['companyDetail-form']}
                    >
                        <Row type="flex" justify="space-between">
                            <Col span={6}>
                                <FormItem label="公司全称">
                                    {
                                        editDetail ? (
                                            getFieldDecorator('companyName', {
                                                initialValue: companyInfo && companyInfo.name,
                                                rules: [
                                                    {
                                                        required: true, message: '请输入公司名称'
                                                    }
                                                ]
                                            })
                                            (<Input/>)
                                        ) : (<span>{companyInfo && companyInfo.name}</span>)
                                    }
                                </FormItem>
                            </Col>
                            <Col span={6}>
                                <FormItem label="纳税人识别号">
                                    {
                                        editDetail ? (
                                            getFieldDecorator('companyTaxid', {
                                                initialValue: companyInfo && companyInfo.taxId,
                                                rules: [
                                                    {
                                                        required: true, message: '请输入纳税人识别号'
                                                    }
                                                ]
                                            })
                                            (<Input disabled={true}/>)
                                        ) : (<span>{companyInfo && companyInfo.taxId}</span>)
                                    }
                                </FormItem>
                            </Col>
                            <Col span={6}>
                                <FormItem label="联系电话">
                                    {
                                        editDetail ? (
                                            getFieldDecorator('companyPhone', {
                                                initialValue: companyInfo && companyInfo.phone
                                            })
                                            (<Input/>)
                                        ) : (<span>{companyInfo && companyInfo.phone}</span>)
                                    }
                                </FormItem>
                            </Col>
                        </Row>
                        <Row type="flex" justify="space-between">
                            <Col span={6}>
                                <FormItem label="国家或地区">
                                    {
                                        editDetail ? (
                                            getFieldDecorator('country', {
                                                initialValue: this.modulesState.snapCountry ? this.modulesState.snapCountry : '中国'
                                            })
                                            (
                                                <Select
                                                    onChange={this.refreshStates}
                                                    showSearch={true}
                                                    optionFilterProp="children"
                                                >
                                                    {countryOpts.map(countryOpt => <Option value={countryOpt.name} key={countryOpt.code}>{countryOpt.name}</Option>)}
                                                </Select>
                                            )
                                        ) : (<span>{companyInfo && companyInfo.location.country}</span>)
                                    }
                                </FormItem>
                            </Col>
                            <Col span={6}>
                                <FormItem label="联系人">
                                    {
                                        editDetail ? (
                                            getFieldDecorator('adminName', {
                                                initialValue: companyInfo && companyInfo.adminName
                                            })
                                            (<Input
                                                disabled={true}    
                                            />)
                                        ) : (<span>{companyInfo && companyInfo.adminName}</span>)
                                    }
                                </FormItem>
                            </Col>
                            <Col span={6}>
                                <FormItem label="电子邮箱">
                                    {
                                        editDetail ? (
                                            getFieldDecorator('adminEmail', {
                                                initialValue: companyInfo && companyInfo.adminEmail
                                            })
                                            (<Input
                                                disabled={true}
                                            />)
                                        ) : (<span>{companyInfo && companyInfo.adminEmail}</span>)
                                    }
                                </FormItem>
                            </Col>
                        </Row>
                        <Row type="flex" justify="space-between">
                            <Col span={6}>
                                <FormItem label="所在城市">
                                    <div className={css['companyDetail-form-city']}>
                                        {
                                            editDetail ? (
                                                getFieldDecorator('state', {
                                                    initialValue: this.modulesState.snapState ? this.modulesState.snapState : undefined
                                                })
                                                (
                                                    <Select
                                                        onChange={this.refreshCities}
                                                        showSearch={true}
                                                        optionFilterProp="children"
                                                        disabled={this.modulesState.snapCountry !== '中国'}
                                                    >
                                                        {stateOptions.map(countryOpt => <Option value={countryOpt.name} key={countryOpt.code}>{countryOpt.name}</Option>)}
                                                    </Select>
                                                )
                                            ) : (<span>{companyInfo && companyInfo.location.state}</span>)
                                        }
                                        {
                                            editDetail ? (
                                                console.log(this.modulesState.snapStateCity),
                                                getFieldDecorator('city', {
                                                    initialValue: this.modulesState.snapStateCity ? this.modulesState.snapStateCity : undefined
                                                })
                                                (
                                                    <Select
                                                        onChange={this.refreshSnapCity}
                                                        showSearch={true}
                                                        optionFilterProp="children"
                                                        disabled={this.modulesState.snapCountry !== '中国'}
                                                    >
                                                        {cityOptions.map(countryOpt => <Option value={countryOpt.name} key={countryOpt.code}>{countryOpt.name}</Option>)}
                                                    </Select>
                                                )
                                            ) : (<span>{companyInfo && companyInfo.location.city}</span>)
                                        }
                                    </div>
                                </FormItem>
                            </Col>
                            <Col span={6}>
                                <FormItem label="详细地址">
                                    {
                                        editDetail ? (
                                            getFieldDecorator('address', {
                                                initialValue: companyInfo && companyInfo.address
                                            })
                                            (<Input/>)
                                        ) : (<span>{companyInfo && companyInfo.address}</span>)
                                    }
                                </FormItem>
                            </Col>
                            <Col span={6}/>
                        </Row>
                    </Form>
                </div>
            </div>
        );
    }

    private updateDetailStatu = (b) => {
        ModulesAction.updateEditStatu('editDetail', b);
    }

    private updateDetail = () => {
        this.props.form.validateFields((err, val)=>{
            if (!err) {
                val.city = val.city ? val.city : '';
                val.country = val.country ? val.country : '';
                val.state = val.state ? val.state : '';
                ModulesAction.detailUpdate(val, ModulesAction.setupDefaultLocation);
                this.updateDetailStatu(false);
            }
        });
    }

    private refreshStates = (name, option) => {
        if(name !== this.modulesState.snapCountry) {
            ModulesAction.countryStates({
                countryCode: option.key
            });
            ModulesAction.countryStateCities();
            ModulesAction.updateSnapCountry(name);
            ModulesAction.updateSnapState('');
            ModulesAction.updateSnapCity('');
            this.props.form.setFieldsValue({ city: undefined, state: undefined });
        }
    }

    private refreshCities = (name, option) => {
        if(name !== this.modulesState.snapState) {
            ModulesAction.updateSnapState(name);
            ModulesAction.countryStateCities({
                stateCode: option.key
            });
            ModulesAction.updateSnapCity(undefined);
            this.props.form.setFieldsValue({ city: undefined});
        }
    }

    private refreshSnapCity = name => {
        ModulesAction.updateSnapCity(name);
    }

    private cancelProtect = () => {
        this.updateDetailStatu(false);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/UI.Detail.tsx